import { Typography } from '@/shared/ui';

interface ReviewDetailsItemProps {
  title: string;
  value?: string;
}
export const ReviewDetailsItem = ({ title, value }: ReviewDetailsItemProps) => {
  return (
    <div className="flex min-h-[64px] flex-col py-2.5">
      <Typography variant="12-r" color="text-base-100" className="break-words">
        {title}
      </Typography>
      <Typography variant="16-r" className="break-words">
        {value ?? '-'}
      </Typography>
    </div>
  );
};
